import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';

import { isLoading, load, get } from '../reducers/meetings';
import { userServiceLayoutConnect } from 'modules/Common/reducers/userService';

import HorseRacingRacecardsForDate from '../components/HorseRacingRacecardsForDate';
import { isoDate, getTomorrowsDate } from 'utils/LocalDateTimeHelper';

function convertDate(date)
{
  if(date == 'tomorrow') {
    date = getTomorrowsDate("YYYY-MM-DD");
  }
  return date;
}

@standardAsyncConnect([
  {
    dispatch: ({params: {date = isoDate()}}) => load(convertDate(date)),
    preventResolve: ({state, params: {date = isoDate()}}) => isLoading(state, convertDate(date)),
    state: state => ({meetingsByDate: get(state)})
  },
  userServiceLayoutConnect()
])
@catchLifeCycleErrors
export default class HorseRacingRacecardsForDateContainer extends Component {
  static propTypes = {
    // supplied by react-router via @connect
    params: PropTypes.shape({
      date: PropTypes.string
    }),
    routes: PropTypes.array.isRequired,
    meetingsByDate: PropTypes.object.isRequired,
    raceType: PropTypes.string
  };

  render() {
    return (
      <HorseRacingRacecardsForDate
        date={convertDate(this.props.params.date) || isoDate()}
        meetingsByDate={this.props.meetingsByDate}
        routes={this.props.routes}
        raceType="Racing"
      />
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingRacecardsForDateContainer.js